import { call, put, takeEvery, all } from 'redux-saga/effects';
import axios from 'axios';
import { tap, forOwn, set } from 'lodash';

import { actions } from './signup-reducer';

const URL = `${process.env.REACT_APP_PUBLIC_API_URL}/signup`;

const errorKeyMap = {
  name: 'account.name',
  first_name: 'user.first_name',
  last_name: 'user.last_name',
  email: 'user.email',
  password: 'user.password',
};

const mapErrorKeys = apiErrors => tap({}, (obj) => {
  forOwn(apiErrors, (value, key) => {
    set(obj, errorKeyMap[key], value);
  });
});

function* submit(action) {
  const { values, setSubmitting, setErrors } = action.payload;

  try {
    const res = yield call(axios.post, URL, { signup: values });
    yield put(actions.submitSuccess(res.data));
    yield setSubmitting(false);
  } catch (err) {
    yield put(actions.submitFail(err.response.data.error.message));
    yield setErrors(mapErrorKeys(err.response.data.error.message));
    yield setSubmitting(false);
  }
}

function* watchSubmit() {
  yield takeEvery(actions.submit().type, submit);
}

export default function* deviceSaga() {
  yield all([
    watchSubmit(),
  ]);
}



// WEBPACK FOOTER //
// ./src/features/Signup/duck/signup-saga.js